module.exports = __webpack_public_path__ + "img/image7.4589f235.jpg";